var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('TextSettings',{attrs:{"object":_vm.object.settings},on:{"update":function($event){return _vm.$emit('update', $event)}}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row col mb-8 mt-14"},[_c('h4',[_vm._v("Text:")])])
}]

export { render, staticRenderFns }